import { useQuery } from "@tanstack/react-query";
import { t } from "../i18n/index.ts";
import { signIn, socialProviders } from "../lib/session.ts";
import { Wordmark } from "../components/Shell.tsx";

/** Google's "G", as its sign-in branding guidelines require on the button. */
function GoogleMark() {
  return (
    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
    </svg>
  );
}

function FacebookMark() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="12" fill="#0866FF" />
      <path fill="#fff" d="M15.12 15.47 15.65 12h-3.33V9.75c0-.95.47-1.87 1.96-1.87h1.51V4.93s-1.37-.23-2.68-.23c-2.74 0-4.53 1.66-4.53 4.66V12H5.53v3.47h3.05v8.39a12.1 12.1 0 0 0 3.74 0v-8.39h2.8z" />
    </svg>
  );
}

export function Welcome() {
  const params = new URLSearchParams(location.search);
  const failed = params.get("signin") === "failed";
  const reason = params.get("reason");
  const returnTo = failed ? "/" : location.pathname + location.search;
  const providers = useQuery({ queryKey: ["auth-providers"], queryFn: socialProviders, staleTime: Infinity }).data ?? [];

  return (
    <div className="center-page">
      <div className="welcome">
        <Wordmark to={null} />
        <h1>{t("welcome.title")}</h1>
        <p>{t("welcome.body")}</p>
        {failed && (
          <div className="banner banner-error" role="alert">
            {reason ? t("welcome.failedReason", { reason }) : t("welcome.failed")}
          </div>
        )}
        <div className="actions">
          {providers.includes("google") && (
            <button className="btn btn-block btn-social" onClick={() => signIn({ returnTo, provider: "google" })}>
              <GoogleMark />{t("welcome.google")}
            </button>
          )}
          {providers.includes("facebook") && (
            <button className="btn btn-block btn-social" onClick={() => signIn({ returnTo, provider: "facebook" })}>
              <FacebookMark />{t("welcome.facebook")}
            </button>
          )}
          {providers.length > 0 && <div className="or"><span>{t("welcome.or")}</span></div>}
          <button className="btn btn-primary btn-block" onClick={() => signIn({ returnTo })}>{t("welcome.signIn")}</button>
          <button className="btn btn-block" onClick={() => signIn({ returnTo, signUp: true })}>{t("welcome.signUp")}</button>
        </div>
      </div>
    </div>
  );
}
